import React, { useEffect, useState } from "react";
import PlantillaScreen from '../../../helpers/PlantillaScreen'
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useBox } from "../../../Finanzas/Helper/useBox";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import request from "../../../../Helpers/API";
import { GetMonthNameByNumber } from "../../../Finanzas/Helper/GetMonthNameByNumber";
import { AgregarPaqueteModal } from "./AgregarPaqueteModal";
import { EditarPaqueteModal } from "./EditarPaqueteModal";
import { ListadoPreciosModal } from "./ListadoPreciosModal";
import Settings from "@mui/icons-material/Settings";
import EditIcon from '@mui/icons-material/Edit';
import { formatFecha } from "../../../Finanzas/Reportes/ResultadosSucursal/formatFecha";

export const ConfiguracionPaquetesScreen = () => {
    const history = useHistory();
    const [boxstate, setBoxState] = useBox();
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [openModalListado, setOpenModalListado] = useState(false);
    const [paquetes, setPaquetes] = useState();
    const [paqueteSelect, setPaqueteSelect] = useState();
    const [paqueteSelectNombre, setPaqueteSelectNombre] = useState();

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModalEditar = (id_paquete) => {
        setPaqueteSelect(id_paquete)
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {
        setPaqueteSelect(0)
        setOpenModalEditar(false);
    };

    const handleOpenModalListado = (id_paquete, paquete) => {
        setPaqueteSelect(id_paquete);
        setPaqueteSelectNombre(paquete);
        setOpenModalListado(true);
    };

    const handleCloseModalListado = () => {
        setPaqueteSelect(0);
        setPaqueteSelectNombre('');
        setOpenModalListado(false);
    };

    const onListadoPrecios = (id_paquete, paquete) => {
        history.push({
            pathname: "/PostVenta/ListadoPreciosMantenimiento",
            state: { id_paquete, paquete }
        });
    };

    useEffect(() => {
        onExecute();
    }, []);

    useEffect(() => {
        if (!openModal && !openModalEditar && !openModalListado) {
            onExecute();
        }
    }, [openModal, openModalEditar, openModalListado]);


    const onExecute = () => {
        setLoader({ ...loader, mostrar: true });
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `DashboardPostventa/PaquetesmantenimientoDisponibles`
                )
                .then((result) => {
                    setPaquetes(result);
                    return;
                })
                .catch((error) => {
                    reject(error);
                    return;
                });
            setLoader({ ...loader, mostrar: false });
        });
    };

    return (
        <PlantillaScreen
            titulo={'CONFIGURACION DE PAQUETES DE MANTENIMIENTO'}
            className={"configuracion-mantenimiento-main-screen"}
            className_main={2}
        >
            <LoaderScreen loader={loader} />
            <div className="configuracion-mantenimiento-actions">
                <div
                    className="configuracion-mantenimiento-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    <button
                        className="configuracion-mantenimiento-header-configuracion"
                        onClick={() => handleOpenModal()}
                    >
                        <Settings /> Agregar paquete
                    </button>
                </div>
            </div>
            <div className="configuracion-mantenimiento-header-info">
                <div className="contador-configuracion-mantenimiento-encontrados">
                    Paquetes disponibles: {paquetes?.length}
                </div>
            </div>
            {paquetes && paquetes.length > 0 && (
                <div className="configuracion-mantenimiento">
                    <div className="configuracion-mantenimiento-container scroll">
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>Paquete</th>
                                    <th>
                                        <div>Periocidad</div>
                                    </th>
                                    {/* <th>
                                        <div>Fecha</div>
                                    </th> */}
                                    <th>
                                        <div>Contenido</div>
                                    </th>
                                    <th>
                                        <div>Opciones</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {paquetes.map((item, index) => (
                                    <tr key={item.id_paquete}>
                                        <td>{item.paquete}</td>
                                        <td>{capitalizePalabras(item.periocidad) + ' meses'}</td>
                                        {/* <td className="ta-center">{item.fecha}</td> */}
                                        <td>{item.contenido}</td>
                                        <td className="celda-opciones">
                                            <div className="paquetes-acciones-listado">
                                                <div
                                                    className="boton-editar-paquetes"
                                                    onClick={() =>
                                                        handleOpenModalEditar(item.id_paquete)
                                                    }
                                                >
                                                    <EditIcon /> Editar
                                                </div>
                                                <div
                                                    className="boton-listado-precios"
                                                    onClick={() => onListadoPrecios(item.id_paquete, item.paquete)
                                                    }
                                                >
                                                    Precios
                                                </div>
                                            </div>

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <AgregarPaqueteModal
                open={openModal}
                onClose={handleCloseModal}
            />
            <EditarPaqueteModal
                open={openModalEditar}
                onClose={handleCloseModalEditar}
                id_paquete={paqueteSelect}
            />
            <ListadoPreciosModal
                open={openModalListado}
                onClose={handleCloseModalListado}
                id_paquete={paqueteSelect}
                paquete={paqueteSelectNombre}
            />
        </PlantillaScreen>
    )
}
